import plantDataConfigApi from '@/api/config/plantDataConfigApi'
import { queryKeys } from '@/constant/common'
import { UpdatePlant } from '@/types/plant'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function update(payload: UpdatePlant): Promise<void> {
  await plantDataConfigApi.update(payload)
}

function useUpdatePlant() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: UpdatePlant) => update(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.plant])
      toast.success(t('updatePlantSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      toast.error(
        error?.message ||
          t('UpdatePlantError'),
      )
    },
  })
}

export default useUpdatePlant
